module.exports = __webpack_public_path__ + "statics/img/andriod.5643e849.png";